// noinspection DuplicatedCode

OffcanvasEventEmitter = function () {};
heir.inherit(OffcanvasEventEmitter, AppEventEmitter);
// noinspection JSCheckFunctionSignatures
OffcanvasEventEmitter.prototype.addListener = function (name, actions, listener) {
    actions = actions instanceof Array ? actions : [ actions ];
    for (var i = 0; i < actions.length; i++) {
        AppEventEmitter.prototype.addListener.call(this, (name + '.' + actions[i]), listener);
    }
};
// noinspection JSCheckFunctionSignatures
OffcanvasEventEmitter.prototype.emitEvent = function (name, action, args) {
    args = args || {};
    args.name = name;
    AppEventEmitter.prototype.emitEvent.call(this, ('*' + '.' + action), [ args ]);
    if ('*' !== name) {
        AppEventEmitter.prototype.emitEvent.call(this, (name + '.' + action), [ args ]);
    }
};

app.offcanvas = new OffcanvasEventEmitter();
app.offcanvas.OPEN_AJAX = 'open_ajax';
app.offcanvas.SHOW = 'show';
app.offcanvas.SHOWN = 'shown';
app.offcanvas.HIDE = 'hide';
app.offcanvas.HIDDEN = 'hidden';
app.offcanvas.LOADED = 'loaded';

app.offcanvas.on('*', app.offcanvas.OPEN_AJAX, function (offcanvas) {
    var $container = $('#container_offcanvas');
    var last = {
        key: $container.attr('data-last-key') || '',
        name: $container.attr('data-last-name') || '',
        type: $container.attr('data-last-type') || ''
    };
    last.id = last.name + (last.key ? '_key_' + last.key : '') + (last.type ? '_type_' + last.type : '');

    var $offcanvas = $('#offcanvas_' + offcanvas.id);
    if ($offcanvas.length === 0) {
        $offcanvas = $(
            '<div class="offcanvas offcanvas-end' + (!offcanvas.width ? ' offcanvas-fullscreen' : '') +'" data-name="' + offcanvas.name + '" data-type="' + offcanvas.type + '" id="offcanvas_' + offcanvas.id + '" style="width: ' + (offcanvas.width || '100vw') + ';" tabindex="-1">' +
                '<div class="modal-dialog" role="document" style="max-width: 100%;">' +
                    '<div class="modal-content border-0" style="background-color: var(--bs-body-bg);">' +
                        '<div class="modal-header border-0 p-0">' +
                            '<button aria-label="Close" class="btn-close btn-close-white position-absolute" data-bs-dismiss="offcanvas" type="button"></button>' +
                        '</div>' +
                        '<div class="modal-body p-0"></div>' +
                    '</div>' +
                '</div>' +
            '</div>'
        ).appendTo($container);
    }

    var instance = new bootstrap.Offcanvas($offcanvas[0], { focus: false });
    instance.show();
    instance._focustrap.activate();
    instance._focustrap.deactivate();

    if (last.id !== offcanvas.id) {
        if (last.name === offcanvas.name) {
            $('#offcanvas_' + last.id).find('.offcanvas-body').html('');
        }
        $container.attr('data-last-key', offcanvas.key || '');
        $container.attr('data-last-name', offcanvas.name || '');
        $container.attr('data-last-type', offcanvas.type || '');
        $offcanvas.find('.modal-body').html('<div class="card bg-dark rounded-0" style="height: 70px;">' +
            '<div class="card-body py-0">' +
                '<div class="text-loading py-3 text-white">Loading</div>' +
                '<div class="d-flex align-items-center justify-content-center w-100" style="height: calc(100vh - 70px);">' +
                    '<div role="status" class="spinner-border avatar-md text-info"></div>' +
                '</div>' +
            '</div>' +
        '</div>');
        $.ajax({
            method: offcanvas.method || 'get',
            url: offcanvas.url,
            data: offcanvas.data
        }).done(function (data) {
            $offcanvas.find('.modal-body').html(data);
            app.offcanvas.trigger(offcanvas.name, app.offcanvas.LOADED, {
                e: $(offcanvas.e),
                event: {
                    type: app.offcanvas.LOADED
                },
                key: offcanvas.key
            });
        }).always(function () {
            $offcanvas.find('.modal-header').find('.spinner-border').parent().remove();
        });
    }
});
$(function () {
    $('body').on('click', '.offcanvas-ajax', function (event) {
        event.preventDefault();
        var key = $(this).attr('data-offcanvas-key') || '';
        var name = $(this).attr('data-offcanvas-name') || '';
        var type = $(this).attr('data-offcanvas-type') || '';
        app.offcanvas.trigger(name, app.offcanvas.OPEN_AJAX, {
            e: $(this),
            id: name + (key ? '_key_' + key : '') + (type ? '_type_' + type : ''),
            key: key,
            name: name,
            type: type,
            url: $(this).attr('href'),
            width: $.proxy(function () {
                var width = $(this).attr('data-offcanvas-width');
                if (!isNaN(width)) {
                    width = width + 'px';
                }
                return width;
            }, this)()
        });
    });
});
$(document).on('show.bs.offcanvas', '.offcanvas', function (event) {
    var $navbar = $('.navbar-custom');
    $navbar.css('padding-right', 'calc(' + $navbar.css('padding-right') + ' + var(--scrollbar-width))');
    app.offcanvas.trigger($(event.target).attr('data-name'), app.offcanvas.SHOW, {
        event: event
    });
});
$(document).on('shown.bs.offcanvas', '.offcanvas', function (event) {
    app.offcanvas.trigger($(event.target).attr('data-name'), app.offcanvas.SHOWN, {
        event: event
    });
});
$(document).on('hide.bs.offcanvas', '.offcanvas', function (event) {
    $(document.body).removeClass('offcanvas-open').addClass('offcanvas-closed');
    setTimeout(function () {
        $(document.body).removeClass('offcanvas-closed');
    }, 100);
    app.offcanvas.trigger($(event.target).attr('data-name'), app.offcanvas.HIDE, {
        event: event
    });
});
$(document).on('hidden.bs.offcanvas', '.offcanvas', function (event) {
    var $navbar = $('.navbar-custom');
    $navbar.css('padding-right', 'calc(' + $navbar.css('padding-right') + ' - var(--scrollbar-width))');
    app.offcanvas.trigger($(event.target).attr('data-name'), app.offcanvas.HIDDEN, {
        event: event
    });
});
{
    app.offcanvas.on('*', app.offcanvas.SHOWN, function (offcanvas) {
        // $(offcanvas.event.target).css('z-index', (function () {
        //     var array = $('.offcanvas.show').not(offcanvas.event.target).map(function () {
        //         return $(this).css('z-index') * 1;
        //     });
        //     if (array.length) {
        //         return Math.max.apply(null, array) + 10;
        //     } else {
        //         return 1050;
        //     }
        // })());
        // $('.offcanvas-backdrop').each(function (index) {
        //     $(this).css('z-index', 1049 + 10 * index);
        //     if ($(this).is($('.offcanvas-backdrop').last())) {
        //         $(this).css('background', '');
        //     } else {
        //         $(this).css('background', 'transparent');
        //     }
        // });
    });
    app.offcanvas.on('*', app.offcanvas.HIDDEN, function (offcanvas) {
        // $(offcanvas.event.target).css('z-index', 1050);
        // $('.offcanvas:last').css('background', '');
        // var $offcanvases = $('.offcanvas.show');
        // if ($offcanvases.length) {
        //     $('body').addClass('offcanvas-open');
        //     var instance = bootstrap.Offcanvas.getInstance($offcanvases.last()[0]);
        //     instance._focustrap.activate();
        //     instance._focustrap.deactivate();
        // }
    });
}

$(document.body).on('click', '.offcanvas', function (e) {
    if ($(this).is($(e.target))) {
        bootstrap.Offcanvas.getInstance($(this)[0]).hide();
    }
});
